import ReactGA from 'react-ga4';

import { GetMenuCM, GetPerekCM, GetPerekHeaderCM, GetPerekNextCM, GetPerekPrevCM } from '../Util/PrakimCM';
import { GetMenuTN, GetPerekTN, GetPerekHeaderTN, GetPerekNextTN, GetPerekPrevTN } from '../Util/PrakimTN';
import { GetMenuTH, GetPerekTH, GetPerekHeaderTH, GetPerekNextTH, GetPerekPrevTH } from '../Util/PrakimTH';
import { GetMenuHY, GetPerekHY, GetPerekHeaderHY, GetPerekNextHY, GetPerekPrevHY } from '../Util/PrakimHY';


const Prakim = {
	GetMenu: function(type) {
		return this["GetMenu"+type.toUpperCase()]();
	},
	GetMenuTN: function() {
		 return GetMenuTN();
	},
	GetMenuTH: function() {
		return GetMenuTH();
	},
	GetMenuCM: function() {
		return GetMenuCM();
	},
	GetMenuHY: function() {
		return GetMenuHY();
	},




	GetPerek: async function (type, id) {
		return this["GetPerek"+type.toUpperCase()](id);
	},
	GetPerekTN: async function (id) {
		return GetPerekTN(id);
	},
	GetPerekTH: async function (id) {
		return GetPerekTH(id);
	},
	GetPerekCM: async function (id) {
		return GetPerekCM(id);
	},
	GetPerekHY: async function (id) {
		return GetPerekHY(id);
	},



	GetPerekHeader: function (type, id) {
		return this["GetPerekHeader"+type.toUpperCase()](id);
	},
	GetPerekHeaderTN: function (id) {
		return GetPerekHeaderTN(id);
	},
	GetPerekHeaderTH: function (id) {
		return GetPerekHeaderTH(id);
	},
	GetPerekHeaderCM: function (id) {
		return GetPerekHeaderCM(id);
	},
	GetPerekHeaderHY: function (id) {
		return GetPerekHeaderHY(id);
	},



	GetPerekNext: function (type, id) {
		return this["GetPerekNext"+type.toUpperCase()](id);
	},
	GetPerekNextTN: function (id) {
		return GetPerekNextTN(id);
	},
	GetPerekNextTH: function (id) {
		return GetPerekNextTH(id);
	},
	GetPerekNextCM: function (id) {
		return GetPerekNextCM(id);
	},
	GetPerekNextHY: function (id) {
		return GetPerekNextHY(id);
	},



	GetPerekPrev: function (type, id) {
		return this["GetPerekPrev"+type.toUpperCase()](id);
	},
	GetPerekPrevTN: function (id) {
		return GetPerekPrevTN(id);
	},
	GetPerekPrevTH: function (id) {
		return GetPerekPrevTH(id);
	},
	GetPerekPrevCM: function (id) {
		return GetPerekPrevCM(id);
	},
	GetPerekPrevHY: function (id) {
		return GetPerekPrevHY(id);
	},
};





export function GetMenu(type) {
	return Prakim.GetMenu(type);
};


export async function GetPerek(type, id) {
	ReactGA.event({ category: 'User',action: 'Perek/' + type});
	return await Prakim.GetPerek(type, id);
};
export function GetPerekHeader(type, id) {
	return Prakim.GetPerekHeader(type, id);
};
export function GetPerekNext(type, id) {
	return Prakim.GetPerekNext(type, id);
};
export function GetPerekPrev(type, id) {
	return Prakim.GetPerekPrev(type, id);
};